import PortableText from '@otovo/shared/components/Sanity/PortableTextComponents';
import SanityImage from '@otovo/shared/components/Sanity/SanityImage';
import { cn } from '@otovo/shared/lib/classNames';
import { Sanity$HorizontalListOfFeatures } from '@otovo/shared/types/sanityTypes';
import { stegaClean } from 'next-sanity';
import FeatureContent from './FeatureContent';

type Props = {
  content: Sanity$HorizontalListOfFeatures;
};

const HorizontalListOfFeatures = ({ content }: Props) => {
  return (
    <div
      className={cn(
        'bg-surface',
        stegaClean(content.colorScheme) === 'white'
          ? 'color-scheme-white'
          : 'color-scheme-dark',
      )}
      data-testid="horizontal-list-of-features"
    >
      <div className="mx-auto max-w-8xl px-4 py-16 md:px-6 md:py-20 lg:px-16 lg:py-24">
        <FeatureContent content={content}>
          <>
            {content.image && (
              <div className="relative col-span-12 mt-8 mb-10 overflow-hidden md:mt-10 xl:mt-24">
                <SanityImage
                  maxHeightFull
                  image={content.image}
                  className="mr-auto aspect-[21/9] h-full w-full rounded-xl object-cover shadow-2xl ring-1 ring-grey-90/10"
                />
              </div>
            )}
            <div
              className={cn('col-span-12', {
                'mt-24': !content.image,
              })}
            >
              {content.features && (
                <dl className="gap-16 md:grid md:grid-cols-2 lg:grid-cols-4">
                  {content.features.map((feature) => (
                    <div
                      key={feature.title}
                      className="relative mb-8 border-t border-t-heading/10 pt-8 md:mb-0"
                    >
                      <dt className="mb-3 block text-2xl font-semibold text-balance text-subheading">
                        {feature.title}
                      </dt>
                      <dd className="block text-body">
                        <PortableText value={feature.description} />
                      </dd>
                    </div>
                  ))}
                </dl>
              )}
            </div>
          </>
        </FeatureContent>
      </div>
    </div>
  );
};

export default HorizontalListOfFeatures;
